import { render, staticRenderFns } from "./TwoMonthAdd.vue?vue&type=template&id=118715a3&"
import script from "./TwoMonthAdd.vue?vue&type=script&lang=ts&"
export * from "./TwoMonthAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports